import { getInitialsFromName } from '@/utils';
import styles from './DoctorCard.module.css';

interface Props {
  name: string;
  subtitle: string;
  /** Shown as a pill under the subtitle, e.g. unread messages. */
  note?: string;
  unavailable?: boolean;
  onSelect: () => void;
}

export function OrganizationCard({ name, subtitle, note, unavailable = false, onSelect }: Props) {
  return (
    <button type="button" className={styles.card} onClick={onSelect} disabled={unavailable} aria-label={`Selecteer ${name}`}>
      <span className={styles.avatar} aria-hidden="true">{getInitialsFromName(name)}</span>
      <span className={styles.main}>
        <span className={styles.name}>{name}</span>
        <span className={styles.subtitle}>{subtitle}</span>
        {unavailable && <span className={styles.unavailablePill}>Niet beschikbaar</span>}
        {!unavailable && note && <span className={styles.notePill}>{note}</span>}
      </span>
      <span className={styles.arrow} aria-hidden="true">›</span>
    </button>
  );
}
